import React from "react";
import * as S from "../styles";
import { optimizedImageUrl } from "../../../../helpers";

const ImagesSection = ({
  blockImages,
  imageTitles,
  draggedImage,
  activeImageDropZone,
  handleThumbnailClick,
  handleImageTitleChange,
  handleImageTitleBlur,
  handleDeleteImage,
  handleImageDragStart,
  handleImageDragEnd,
  handleImageZoneDragOver,
  handleImageZoneDragLeave,
  handleImageZoneDrop,
  showAddImageModal,
  setShowAddImageModal,
  replacingImageId,
  uploadingReplace,
  replaceFileInputRef,
  uploadingImage,
  fileInputRef,
}) => {
  return (
    <S.Section>
      <S.SectionTitle>Изображения ({blockImages.length})</S.SectionTitle>

      {blockImages.length === 0 ? (
        <p style={{ color: "#999", fontSize: "14px" }}>
          Нет привязанных изображений
        </p>
      ) : (
        <S.ImageList>
          <S.DropZone
            $active={draggedImage !== null}
            $isOver={activeImageDropZone === 0}
            onDragOver={(e) => handleImageZoneDragOver(e, 0)}
            onDragLeave={() => handleImageZoneDragLeave(0)}
            onDrop={(e) => handleImageZoneDrop(e, 0)}
          >
            {activeImageDropZone === 0
              ? "Вставить в начало"
              : draggedImage !== null
                ? "Зона переноса"
                : ""}
          </S.DropZone>
          {blockImages.map((r, index) => (
            <React.Fragment key={r.image_id}>
              <S.ImageItem
                draggable
                onDragStart={(e) => handleImageDragStart(e, r.image_id)}
                onDragEnd={handleImageDragEnd}
                style={{
                  opacity: draggedImage === r.image_id ? 0.4 : 1,
                }}
              >
                <S.DragHandle>{r.display_order + 1}</S.DragHandle>

                <S.Thumbnail onClick={() => handleThumbnailClick(r.image_id)}>
                  <S.ThumbnailImg
                    src={optimizedImageUrl("md", r.original)}
                    alt={r.title || ""}
                  />
                </S.Thumbnail>
                <S.ImageInfo>
                  <S.ImageTitleInput
                    type="text"
                    value={imageTitles[r.image_id] || r.title || ""}
                    onChange={(e) =>
                      handleImageTitleChange(r.image_id, e.target.value)
                    }
                    onBlur={(e) =>
                      handleImageTitleBlur(r.image_id, e.target.value)
                    }
                    placeholder="Заголовок"
                  />
                  <S.ImageFileName>{r.original}</S.ImageFileName>
                </S.ImageInfo>
                <S.DeleteButton onClick={() => handleDeleteImage(r.image_id)}>
                  Удалить
                </S.DeleteButton>
              </S.ImageItem>

              <S.DropZone
                $active={draggedImage !== null}
                $isOver={activeImageDropZone === index + 1}
                onDragOver={(e) => handleImageZoneDragOver(e, index + 1)}
                onDragLeave={() => handleImageZoneDragLeave(index + 1)}
                onDrop={(e) => handleImageZoneDrop(e, index + 1)}
              >
                {activeImageDropZone === index + 1
                  ? index === blockImages.length - 1
                    ? "Вставить в конец"
                    : "Вставить сюда"
                  : draggedImage !== null
                    ? "Зона переноса"
                    : ""}
              </S.DropZone>
            </React.Fragment>
          ))}
        </S.ImageList>
      )}

      <S.AddButton onClick={() => setShowAddImageModal(true)}>
        Добавить изображение
      </S.AddButton>

      {/* Add Image Modal */}
      {showAddImageModal && (
        <S.ModalOverlay onClick={() => setShowAddImageModal(false)}>
          <S.Modal onClick={(e) => e.stopPropagation()}>
            <S.ModalTitle>Добавить изображение</S.ModalTitle>
            <S.OptionButton onClick={() => fileInputRef.current?.click()}>
              📁 Загрузить файл
            </S.OptionButton>
            <input
              ref={fileInputRef}
              type="file"
              accept="image/*"
              style={{ display: "none" }}
              onChange={(e) => {
                const file = e.target.files[0];
                if (!file) return;
                setShowAddImageModal(false);
              }}
            />

            {uploadingImage && <S.Loading>Загрузка...</S.Loading>}

            <S.ModalActions>
              <S.CancelButton onClick={() => setShowAddImageModal(false)}>
                Отменить
              </S.CancelButton>
            </S.ModalActions>
          </S.Modal>
        </S.ModalOverlay>
      )}

      {/* Replace Image Modal */}
      {replacingImageId !== null && (
        <S.ModalOverlay onClick={() => {}}>
          <S.Modal onClick={(e) => e.stopPropagation()}>
            <S.ModalTitle>Заменить изображение</S.ModalTitle>
            <S.OptionButton
              onClick={() => replaceFileInputRef.current?.click()}
            >
              📁 Выбрать новый файл
            </S.OptionButton>
            <input
              ref={replaceFileInputRef}
              type="file"
              accept="image/*"
              style={{ display: "none" }}
              onChange={() => {}}
            />
            {uploadingReplace && <S.Loading>Загрузка...</S.Loading>}
            <p style={{ fontSize: "13px", color: "#888", marginTop: "10px" }}>
              Старый файл будет удалён, связи останутся прежними.
            </p>
            <S.ModalActions>
              <S.CancelButton onClick={() => {}}>
                Отмена
              </S.CancelButton>
            </S.ModalActions>
          </S.Modal>
        </S.ModalOverlay>
      )}
    </S.Section>
  );
};

export default ImagesSection;
